import { Dataset, GridRow } from '../../../types/types';
import { ReportRowsBySource, ReportTemplate } from '../types';

export interface ReportMeasureKeyInput {
  template: ReportTemplate | undefined;
  itemRows: GridRow[];
  rowsBySource: ReportRowsBySource;
  definitionsBySource: Record<string, Dataset>;
  activeFilters: Record<string, unknown> | null;
  activeFiltersBySource?: Record<string, Record<string, unknown>>;
  language: string;
  printedAt: Date;
  sheetWidthMm: number;
  sheetHeightMm: number;
  isLoading: boolean;
  assetUrls: Record<string, string>;
}

/** Content identity used by the DOM measurement pass. */
export const buildReportMeasureKey = ({
  template,
  itemRows,
  rowsBySource,
  definitionsBySource,
  activeFilters,
  activeFiltersBySource,
  language,
  printedAt,
  sheetWidthMm,
  sheetHeightMm,
  isLoading,
  assetUrls,
}: ReportMeasureKeyInput): string =>
  JSON.stringify({
    // Height can change while the internal id and row count stay equal: another
    // stored layout may select different columns, and different text can wrap.
    template,
    itemRows,
    rowsBySource,
    definitionsBySource,
    activeFilters,
    activeFiltersBySource,
    language,
    printedAt: printedAt.toISOString(),
    sheetWidthMm,
    sheetHeightMm,
    isLoading,
    assetUrls: Object.entries(assetUrls).sort(([left], [right]) =>
      left.localeCompare(right)
    ),
  });
